// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"5d7007e1","709":"045037c1","731":"ad195f22","823":"c6ee0353"}[chunkId] + ".chunk.js";
};